// Is Remote Punch switched on for this company? (superadmin → Company
// Configuration → Remote Punch settings). False until the server answers, and
// on any error, so a switched-off feature never flashes its buttons.
import { useEffect, useState } from "react";
import { remotePunchApi } from "./remotePunchApi";

export const useRemotePunchEnabled = (clientName) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    remotePunchApi.status({ clientName })
      .then((data) => { if (!cancelled) setEnabled(data?.enabled === true); })
      .catch(() => { if (!cancelled) setEnabled(false); });
    return () => { cancelled = true; };
  }, [clientName]);

  return enabled;
};

export default useRemotePunchEnabled;
